<template>
  <b-list-group-item
    button
    :active="active"
    class="d-flex flex-column align-items-start"
    @click="$emit('select', conversation.id)"
  >
    <div class="d-flex w-100 justify-content-between align-items-center">
      <div class="d-flex align-items-baseline text-truncate">
        <!-- Prefer the linked contact's name; fall back to the raw number when
             the conversation is not linked to a contact yet. Interpolated, never
             v-html: contactName resolves from our DB, profileName is whatever the
             customer typed into WhatsApp — both are untrusted for markup. -->
        <strong>{{ conversation.contactName || conversation.waPhone }}</strong>
        <small
          v-if="
            conversation.profileName &&
            conversation.profileName !== conversation.contactName
          "
          class="text-muted ml-2 text-truncate"
        >
          {{ conversation.profileName }}
        </small>
      </div>
      <small
        v-if="conversation.lastMessageAt"
        class="text-muted flex-shrink-0 ml-2"
      >
        {{ conversation.lastMessageAt | moment('from') }}
      </small>
    </div>
    <!-- Show the number as a secondary line when a contact name occupies the
         first line, and the account the contact belongs to. -->
    <div
      v-if="conversation.contactName || conversation.accountName"
      class="d-flex w-100 justify-content-between align-items-center text-truncate"
    >
      <small v-if="conversation.contactName" class="text-muted text-truncate">
        {{ conversation.waPhone }}
      </small>
      <small
        v-if="conversation.accountName"
        class="text-muted text-truncate ml-2"
      >
        {{ conversation.accountName }}
      </small>
    </div>
    <div class="d-flex w-100 justify-content-between align-items-center mt-1">
      <small class="text-muted">
        {{ conversation.status || $t('whatsapp.conversation.no-status') }}
      </small>
      <b-badge :variant="windowVariant">{{ windowLabel }}</b-badge>
    </div>
  </b-list-group-item>
</template>

<script>
export default {
  name: 'ConversationListItem',
  props: {
    conversation: { type: Object, required: true },
    active: { type: Boolean, default: false },
  },
  computed: {
    // The 24h service window is derived server-side from the last inbound
    // message; Meta never reports it. The strict `=== true` is deliberate: if the
    // field is ever absent, the window reads closed, which is the safe claim. The
    // expensive mistake is telling staff a free-form reply will be delivered when
    // Meta will reject it.
    windowOpen() {
      return this.conversation.timeWindowOpen === true;
    },
    windowVariant() {
      return this.windowOpen ? 'success' : 'secondary';
    },
    windowLabel() {
      return this.windowOpen
        ? this.$t('whatsapp.window.open')
        : this.$t('whatsapp.window.closed');
    },
  },
};
</script>
